import { Select, Typography } from 'antd';
import React from 'react';
import { ExternalSourceEnum } from '../../utils/api';

const sources = [
    { value: ExternalSourceEnum.Mvlsz, label: 'Hungary' },
    { value: ExternalSourceEnum.Eurocup, label: 'Euro Cup (legacy, historical seasons)' },
    {
        value: ExternalSourceEnum.ChampionsLeague,
        label: 'Champions League (legacy, historical seasons)',
    },
    { value: ExternalSourceEnum.Microplus, label: 'European Aquatics (Microplus)' },
];

export const externalSourceLabel = (source: ExternalSourceEnum): string =>
    sources.find((option) => option.value === source)?.label || '';

export default function ExternalSourceSelect({
    value,
    onChange,
    disabled,
}: {
    value: ExternalSourceEnum;
    onChange?: (source: ExternalSourceEnum) => void;
    disabled?: boolean;
}): React.ReactElement {
    const legacy =
        value === ExternalSourceEnum.Eurocup || value === ExternalSourceEnum.ChampionsLeague;
    return (
        <div style={{ display: 'inline-flex', flexDirection: 'column', marginBottom: 16 }}>
            <Select
                aria-label="External source"
                value={value}
                onChange={onChange}
                disabled={disabled}
                style={{ width: legacy ? 380 : 280 }}
                options={sources}
            />
            {legacy && !disabled && (
                <Typography.Text type="secondary">
                    For current seasons, use European Aquatics (Microplus).
                </Typography.Text>
            )}
        </div>
    );
}
